import { render } from "./reset-succ.vue?vue&type=template&id=41169828&ts=true"
import script from "./reset-succ.vue?vue&type=script&lang=ts"
export * from "./reset-succ.vue?vue&type=script&lang=ts"

import "./reset-succ.vue?vue&type=style&index=0&id=41169828&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__